import { createApp } from 'vue'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import router from './router'
import App from './App.vue'
import { generateApi, apiKey } from './libs/api'
import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import { l, lang } from './libs/localization'

dayjs.extend(isToday)
document.documentElement.lang = lang

const app = createApp(App)
app.config.globalProperties.l = l
if (import.meta.env.PROD) {
  Sentry.init({
    app,
    dsn: 'https://50d901fe39044288942ef85349c37d97@o569163.ingest.sentry.io/4504073128509440',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['drawtalk.laineus.com', /^\//],
      })
    ],
    tracesSampleRate: 1.0,
    ignoreErrors: [
      // ネットワーク関連
      'Network Error',
      'Unable to preload',
      'Request failed',
      'Importing a module',
      'Failed to fetch dynamically imported module',
      'Request aborted',
      'timeout exceeded',
      // Firebase関連
      'messaging/unsupported-browser',
      'installations/app-offline',
      // ブラウザ/IndexedDB
      'Connection to Indexed Database server lost',
      // 広告関連
      'adsbygoogle.push() error',
      'Accessing domItems after disposal',
      // その他ブラウザ拡張/外部
      'ResizeObserver loop',
      '__firefox__',
      // Service Worker
      /serviceWorker.*Rejected/i
    ],
    beforeSend(event, hint) {
      const error = hint.originalException
      const errorMessage = typeof error === 'string' 
        ? error 
        : (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string')
          ? error.message
          : ''
      
      // 広告スクリプト関連のエラーを無視
      if (event.exception?.values?.[0]?.stacktrace?.frames?.some(frame => 
        frame.filename?.includes('pagead') ||
        frame.filename?.includes('adsbygoogle') ||
        frame.filename?.includes('adsense')
      )) {
        return null
      }
      
      // ブラウザ拡張やReader Mode関連のエラーを無視
      if (errorMessage.includes('__firefox__') || errorMessage.includes('reader')) {
        return null
      }
      
      return event
    }
  })
}

const getFingerprint = () => {
  return FingerprintJS.load().then(fs => fs.get().then(result => result.visitorId))
}

getFingerprint().then(fingerprint => {
  const api = generateApi(fingerprint)
  app.config.globalProperties.window = window
  app.use(router)
  app.provide(apiKey, api)
  app.mount('#app')
})

window.addEventListener('load', () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/serviceWorker.js')
  }
})
